// Identificador de invitado: permite crear/gestionar un hold de reserva (fecha, dirección, etc.)
// sin sesión iniciada. Vive en localStorage para sobrevivir el salto a /iniciar-sesion y volver.
const CLAVE = "zervicy_idInvitado";

/**
 * Devuelve el idInvitado guardado en este navegador, generando uno nuevo si no existe.
 */
export function obtenerIdInvitado() {
    try {
        const existente = window.localStorage.getItem(CLAVE);
        if (existente) return existente;

        const nuevo = crypto.randomUUID();
        window.localStorage.setItem(CLAVE, nuevo);
        return nuevo;
    } catch (err) {
        // localStorage no disponible (modo privado, etc.) — generamos uno de un solo uso.
        return crypto.randomUUID();
    }
}

/**
 * Lee el idInvitado guardado sin generar uno nuevo si no existe (para no crear un
 * invitado "fantasma" cuando el visitante ya tiene sesión iniciada desde el principio).
 */
export function leerIdInvitado() {
    try { return window.localStorage.getItem(CLAVE) || null; }
    catch (err) { return null; }
}

/**
 * Se llama tras reclamar el hold con éxito (usuario ya logueado) para no reusarlo después.
 */
export function limpiarIdInvitado() {
    try { window.localStorage.removeItem(CLAVE); }
    catch (err) { /* no-op */ }
}
